import { t } from '../i18n';

/**
 * Shown when no card is left to show (T083, FR-021). With filters set: says nothing matches, with
 * a one-tap way back to the whole cellar. With no filter at all, it only means every wine is out
 * of bottles (hidden by default, FR-022): says so, with a one-tap way to show them.
 */
export function EmptyState({
  filtered,
  onReset,
  onShowFinished,
}: {
  filtered: boolean;
  onReset: () => void;
  onShowFinished: () => void;
}) {
  return (
    <div className="empty-state" role="status">
      <p>{t(filtered ? 'filters.empty' : 'filters.allFinished')}</p>
      <button type="button" className="cta-nav" onClick={filtered ? onReset : onShowFinished}>
        {t(filtered ? 'filters.reset' : 'filters.showFinished')}
      </button>
    </div>
  );
}
